// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (min-width: 1280px) and (max-width: 1419px) {\n.profileCard[data-v-6629b16d]{\n    width: calc(100% - 392px);\n    overflow: scroll;\n}\n}\n@media screen and (min-width: 1420px) {\n.profileCard[data-v-6629b16d]{\n    width: 75%;\n    overflow: scroll;\n}\n}\n", ""]);
// Exports
module.exports = exports;
